import React, { useEffect, useRef } from "react";

export default function GalleryModal({ isOpen, onClose, children }) {
  const closeButtonRef = useRef(null);
  const previousActiveElementRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    previousActiveElementRef.current = document.activeElement;
    const previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    if (closeButtonRef.current) {
      closeButtonRef.current.focus();
    }

    return () => {
      document.body.style.overflow = previousBodyOverflow;

      if (previousActiveElementRef.current?.focus) {
        previousActiveElementRef.current.focus();
      }
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="gallery-modal" data-testid="gallery-modal">
      <div
        className="gallery-overlay"
        onClick={onClose}
        data-testid="gallery-overlay"
      />
      <div
        className="gallery-content"
        role="dialog"
        aria-modal="true"
        data-testid="gallery"
      >
        {children}
        <button
          type="button"
          className="gallery-close"
          onClick={onClose}
          aria-label="Закрыть галерею"
          ref={closeButtonRef}
        >
          ×
        </button>
      </div>
    </div>
  );
}
